<template>
    <div>
        <div class="e-title">基础信息</div>
        <el-descriptions style="margin-bottom: 20px" :column="2">
            <el-descriptions-item label="cookie ID">{{ form.uuid }}</el-descriptions-item>
            <el-descriptions-item label="IP地址">{{ form.ip }}</el-descriptions-item>
            <el-descriptions-item label="浏览器类型">{{ form.browser_type }}</el-descriptions-item>
            <el-descriptions-item label="操作系统">{{ form.os }}</el-descriptions-item>
            <el-descriptions-item label="标签">
                <el-tag v-for="(item, index) in form.label" :key="index">{{ item.name }}</el-tag>
            </el-descriptions-item>
            <el-descriptions-item label="访问日期">{{ form.last_login_time }}</el-descriptions-item>
        </el-descriptions>
        <div class="e-title">浏览记录</div>
        <ListPage
            style="margin-top: -20px"
            :search="false"
            :query="query"
            :total="total"
            v-loading="loading"
            :data="tableData"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
        >
            <template slot="columns">
                <el-table-column label="序号" align="center" type="index" width="80" />
                <el-table-column label="商品名称" align="center" prop="goods.name" />
                <el-table-column label="分类" align="center" prop="goods.category.name" />
                <el-table-column label="点击次数" align="center" prop="view_goods_times" />
                <el-table-column label="停留时长" align="center" prop="view_goods_time" />
                <el-table-column label="时间" align="center" prop="create_time" />
            </template>
        </ListPage>
        <el-button type="primary" style="width: 120px" @click="$router.back()"> 返回 </el-button>
    </div>
</template>

<script>
import { detail } from "@/api/user/list";
import listMixin from "@/mixins/list";
export default {
    data() {
        return {
            form: {},
        };
    },
    mixins: [listMixin],
    mounted() {
        const uuid = this.$route.query.uuid;
        this.getDetail(uuid);
    },
    methods: {
        getDetail(uuid) {
            detail({ uuid }).then(({ code, error, result }) => {
                if (code === 200) {
                    this.form = result || {};
                    this.tableData = result.history || [];
                } else {
                    this.$message.error(error.message);
                }
            });
        },
    },
};
</script>

<style></style>
